import { render, staticRenderFns } from "./liveDetail.vue?vue&type=template&id=0e35c9a9&scoped=true"
import script from "./liveDetail.vue?vue&type=script&lang=js"
export * from "./liveDetail.vue?vue&type=script&lang=js"
import style0 from "./liveDetail.vue?vue&type=style&index=0&id=0e35c9a9&prod&lang=scss&scoped=true"
import style1 from "./liveDetail.vue?vue&type=style&index=1&id=0e35c9a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e35c9a9",
  null
  
)

export default component.exports